import React, { useEffect, useRef, useState } from 'react';


import { alterNotification } from '../../store/schemas/notificationSlice';
import { useDispatch, useSelector } from 'react-redux';

import { claimFaucet, getBlockTime, getFaucet, manageNetwork } from '../../httpcalls/contractThunk';
import Tilt from 'react-parallax-tilt';
import { updateMetaAuthHappening } from '../../store/schemas/authManagementSlice';
import { ClientOnly } from '../../../library/client/serverCallHandler';
import Auth from '../../auth/authWindow';
import useEffectClient from '../../helpers/networkHook';
import NetworkButton from '../../components/global/networkButton';


const FaucetForm = (props) => {
    const dispatch = useDispatch();
    const isFaucetTimedOut = true
    const faucetTime = 30
    const userActive = useSelector(state => state.authManagement.accounts[0])
    const epoch = useSelector(state => state.mainapp.stakingSlice.epoch)
    const lockTime = useSelector(state => state.mainapp.stakingSlice.lastClaimTime)
    const blockDate = useSelector(state => state.mainapp.stakingSlice.blockTime)
    const network = useSelector(state => state.authManagement.network)

    useEffectClient(() => {
        dispatch(getFaucet())
    }, [network])



    const getNewBlock = async (e = null) => {
        if (e != null) {
            e.target.classList.add('spinnerCss')
        }
        await dispatch(getFaucet())
        if (e != null) {
            setTimeout(async () => {
                e.target.classList.remove('spinnerCss')
            }, 1000)
        }

    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (e.target[0].value != '') {
            dispatch(claimFaucet({ address: e.target[0].value }))

        }
        else {
            dispatch(alterNotification({ position: 'bottom-left', alertStyle: 'error', messageTitle: "Faucet Error", message: "No address given", visible: true }))
        }
    };


    return (
        <>

            <div className='faucet-wrapper vivify fadeIn duration-300'>
                {/*     <div className="dash-label"> <p style={{ display: 'inline-block', fontWeight: 500 }}>{"To see earnings, import the Pluri token address : " + process.env.REACT_APP_PLURI}</p>         </div> */}
                <form onSubmit={
                    (e) => {
                        handleSubmit(e);
                    }
                } className='faucet-form'>
                    <input className='input-field' name='address' type="text" placeholder="Enter your address" />



                    {epoch != null ?
                        
                        <div className='faucet-inputs'>
                            <NetworkButton classes={'button'}>
                                <button className='button'><span>Claim <p>{(1 / epoch.size).toFixed(epoch.size.toString().length + 2)} PLURI</p></span></button>
                            </NetworkButton>
                        </div>
                       
                        
                        :
                        ""
                    }



                </form>
                {

                    <p className='vivify blink delay-200'><i style={{ cursor: "pointer" }} onClick={(e) => { getNewBlock(e) }} className='material-icons-outlined'>sync</i>
                        Claims Status: {
                            (() => {
                                if (lockTime == null && blockDate == null) {
                                    return (
                                        <>Getting faucet stats</>
                                    )
                                }
                                else {
                                    const oldDate = new Date(lockTime)
                                    const newDate = new Date(blockDate)
                                    const differenceMilliseconds = newDate.getTime() - oldDate.getTime(); // Get the difference in milliseconds
                                    const dif = Math.floor(differenceMilliseconds / 1000);
                                    if (dif >= 0) {

                                        return (
                                            <>Current available claims is <b>{parseInt(dif / 60)}</b></>
                                        )
                                    }
                                    else {
                                        return (
                                            <>Next available claim is <b>{newDate.toString()}</b></>
                                        )
                                    }
                                }
                            })()



                        }
                    </p>

                }

            </div>


            <style dangerouslySetInnerHTML={{
                __html: `
                .faucet-inputs > .button {
                    padding: 13px 40px;
                    height: 50px;
                    margin-top: 0px;
                }
            `}} />
        </>
    );
};

export default FaucetForm;
